import { createNextState, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { allCategoryGroupNames } from 'config/filters'
import { CategoryGroupName, Filter } from 'typings/filters'
import { FilterSet } from '../saved'

type AppliedFilters = {
  value: Record<CategoryGroupName, Filter[]>
}

const initialState: AppliedFilters = {
  value: allCategoryGroupNames.reduce(
    (acc, groupName) => ({ ...acc, [groupName]: [] }),
    {} as Record<CategoryGroupName, Filter[]>
  ),
}

const appliedFiltersSlice = createSlice({
  name: 'applied',
  initialState,
  reducers: {
    applyFilters(state, action: PayloadAction<Filter[]>) {
      const nextState = action.payload.reduce(
        (acc, curr) => {
          acc[curr.categoryGroup].push(curr)
          return acc
        },
        allCategoryGroupNames.reduce(
          (acc, groupName) => ({ ...acc, [groupName]: [] }),
          {} as Record<CategoryGroupName, Filter[]>
        )
      )
      state.value = nextState
    },
    removeFilter(state, action: PayloadAction<Filter>) {
      state.value = createNextState(state.value, (draft) => {
        const key = action.payload.categoryGroup
        draft[key] = state.value[key].filter(
          ({ variable_id, answer_code }) =>
            !(
              variable_id === action.payload.variable_id &&
              answer_code === action.payload.answer_code
            )
        )
      })
    },
    applyImportedFilters(state, action: PayloadAction<FilterSet[]>) {
      const filterSetToApply = action.payload?.find((filter) => filter.isApplied)

      if (filterSetToApply) {
        return { value: filterSetToApply.filters }
      }

      return state
    },
  },
})

export const { applyFilters, removeFilter, applyImportedFilters } = appliedFiltersSlice.actions

export default appliedFiltersSlice.reducer
